import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import axios from "axios";
import './Login.css'; // Import your CSS file


function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
       
    } catch (error) {
      alert(error);
    }
  }; 

  return (
    <div class="login-container">
        <div class="image-div"><img src="/images/login_Illustration.svg"/></div>
        <div class="form-div">
        <div class="form-container"> 
              <img src="/logo.png" alt="Brilliant Prep Logo" class="logo"/>
              <div class="form-header">Sign In</div>
              <a href="#" class="signup-link"><span>No account yet?</span> Sign up →</a>
               
              <form 
                 autoComplete="off" 
                 onSubmit={(e) => handleSubmit(e)}>
                <div class="inputBox"> 
                    <input
                    placeholder="New Password"
                    id="pass"
                    type="password"
                    name="password"
                    onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })} />

                    
                    <input
                    placeholder="Confirm Password"
                    id="pass"
                    type="password"
                    name="password"
                    onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })} />
                
                </div> 

                <div class="login-btn">
                  <input type="submit" value="Reset Password" />
                </div>

                <div class="forgotpassword">
                  <a href="#" class="forgot-link">Forgot Password?</a>
                </div>
              </form>
              {message && <p style={{ color: 'green' }}>{message}</p>}
              {error && <p style={{ color: 'red' }}>{error}</p>}
            </div>
        </div>
  </div>
  );
}

export default ResetPassword;
